export default "__VITE_ASSET__CcMfaqXa__"